import axios from "axios";
import {
  Button,
  Callout,
  CalloutText,
  CalloutTitle,
  Col,
  Container,
  Icon,
  Input,
  Row,
  Spinner,
} from "design-react-kit";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useHttp from "../../hooks/useHttp";
import { endpoints } from "../../types/config";
import CustomModal from "../CustomModal/CustomModal";
import Done from "../Done/Done";

interface UserValidationProps { }

const UserValidation: React.FC<UserValidationProps> = () => {
  const { pathname, search, state } = useLocation();
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const [isRejectOpen, setIsRejectOpen] = useState(false);
  const { error, isLoading, sendRequest: getUserInfo } = useHttp();
  const [approveError, setApproveError] = useState<Error | null>();
  const [approveLoading, setApproveLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();
  const [attachment, setAttachment] = useState("");
  const [attachment_mimetype, setAttachmentMimetype] = useState("");
  const [userData, setUserData] = useState<UserData>({
    codice_ipa: "",
    creation_date: "",
    denominazione_ente: "",
    email: "",
    fiscal_code: "",
    name: "",
    surname: "",
    phone: "",
    role: ""
  });

  const approveUser = async () => {
    //http request
    try {
      setApproveLoading(true);
      const form = new FormData();
      const urlPaths = pathname.split("/");
      const token = urlPaths.length > 2 ? urlPaths[2] : "";
      form.append("requestToken", token);
      form.append("attachment", attachment);
      form.append("attachmentMimetype", attachment_mimetype);
      const response = await axios.post(endpoints.approve.path, form);
      //console.log(response);
      if (!response.data.success) {
        throw {
          message: "Richiesta fallita, impossibile approvare.",
        };
      }
      setDone(true);
    } catch (e) {
      setApproveError(e as Error);
    } finally {
      setApproveLoading(false);
      setIsApproveOpen(false);
    }
  };

  const rejectUser = async () => {
    try {
      setApproveLoading(true);
      const form = new FormData();
      const urlPaths = pathname.split("/");
      const token = urlPaths.length > 2 ? urlPaths[2] : "";
      form.append("requestToken", token);
      const response = await axios.post(endpoints.reject.path, form);

      if (!response.data.success) {
        throw {
          message: "Richiesta fallita, impossibile rifiutare.",
        };
      }
      setDone(true);
    } catch (e) {
      setApproveError(e as Error);
    } finally {
      setApproveLoading(false);
      setIsRejectOpen(false);
    }
  };

  const fetchUserInfo = async () => {
    const urlPaths = pathname.split("/");
    const t = urlPaths.length > 2 ? urlPaths[urlPaths.length - 1] : "";
    await getUserInfo<{ success: true; result: UserData }, RequestError>(
      {
        url: endpoints.request.path,
        params: { [endpoints.request.params[0]]: t },
      },
      (errorRes) => {
        console.log("errorRes", errorRes);
        if (!errorRes.success) {
          throw {
            message: errorRes.message ?? "Richiesta fallita.",
          };
        }
      },
      (data) => {
        if (data.success) setUserData({ ...data.result });
      }
    );

    //console.log("t", pathname);
  };
  React.useEffect(() => {
    fetchUserInfo();
  }, []);

  if (error || pathname.split("/").length < 2) {
    return (
      <Container className="d-flex justify-content-center flex-column align-items-center">
        <Done
          title=""
          body="Richiesta utente non trovata o scaduta."
          icon="it-close-circle"
        />
        {/* <h5 className="text-danger w-50">{error?.message}</h5> */}
      </Container>
    );
  } else {
    return (
      <div style={{ transition: "all .35s ease-in-out" }}>
        <div
          style={{
            display: isLoading ? "flex" : "none",
            justifyContent: "center",
            width: "100%",
          }}>
          <Container className="d-flex justify-content-center flex-column align-items-center">
            <Spinner active={true} />
            <h6 className="mt-4">Richiesta in corso...</h6>
          </Container>
        </div>

        <Callout
          color="note"
          detailed
          style={{
            width: "clamp(80%,400px,100%)",
            display: isLoading ? "none" : "",
            margin: "0 auto",
          }}>
          <CalloutTitle>
            <Icon icon="it-check-circle" padding={false} aria-hidden />
            <span>Approva Utente</span>
          </CalloutTitle>
          <CalloutText>
            <Row>
              <Col>
                <h6 className="font-weight-bold">Nome</h6>
                <h6 className="font-italic text-muted">{userData.name}</h6>
              </Col>
              <Col>
                <h6 className="font-weight-bold">Cognome</h6>
                <h6 className="font-italic text-muted">{userData.surname}</h6>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col>
                <h6 className="font-weight-bold">E-mail</h6>
                <h6 className="font-italic text-muted">{userData.email}</h6>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col>
                <h6 className="font-weight-bold">Numero aziendale</h6>
                <h6 className="font-italic text-muted">
                  {userData.phone}
                </h6>
              </Col>
            </Row>
            <Row>
              <Col>
                <h6 className="font-weight-bold">Numero di cellulare</h6>
                <h6 className="font-italic text-muted">
                  {userData.phoneNumber}
                </h6>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col>
                <h6 className="font-weight-bold">Codice Fiscale</h6>
                <h6 className="font-italic text-muted">
                  {userData.fiscal_code}
                </h6>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col>
                <h6 className="font-weight-bold">Ruolo nell'amministrazione</h6>
                <h6 className="font-italic text-muted">
                  {userData.role}
                </h6>
              </Col>
            </Row>
            <Row>
              <Col>
                <h6 className="font-weight-bold">Amministrazione</h6>
                <h6 className="font-italic text-muted">
                  {userData?.denominazione_ente}
                </h6>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col>
                <h6 className="font-weight-bold">IPA</h6>
                <h6 className="font-italic text-muted">
                  {userData.codice_ipa}
                </h6>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col>
                <h6 className="font-weight-bold">Data</h6>
                <h6 className="font-italic text-muted">
                  {userData.creation_date}
                </h6>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col>
                <h6 className="font-weight-bold"> File Upload (.pdf, .p7m)</h6>
                <Input
                  id="theFile"
                  onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                    let theFile = document.getElementById(
                      "theFile"
                    ) as HTMLInputElement;
                    theFile.value = "";
                    setAttachment("");
                    setAttachmentMimetype("");
                  }}
                  onChange={(e) => {
                    const file = new FileReader();
                    file.onload = (e) => {
                      if (e.target) {
                        let mimetype = (e.target.result as string).replace("data:", "").split(";")[0],
                          ext = (document.getElementById(
                            "theFile"
                          ) as HTMLInputElement).value.split(".").slice(-1)[0];
                        console.log(ext, mimetype)
                        if (!e.target.result || e.target.result === "") {
                          return;
                        } else if (!(ext === 'pdf' || ext === 'p7m')) {
                          return
                        }
                        setAttachment(
                          (e.target.result as string).split(",")[1]
                        );
                        setAttachmentMimetype(
                          `${ext};${mimetype}`
                        );
                      }
                    };
                    if (e.target && e.target.files && e.target.files[0]) {
                      file.readAsDataURL(e.target.files[0]);
                    } else {
                      setAttachment("");
                      setAttachmentMimetype("");
                    }
                  }}
                  className="mt-1"
                  type="file"
                  accept="application/pdf,application/pkcs7-mime"
                />
              </Col>
            </Row>
          </CalloutText>
          <div style={{ width: "100%", borderBottom: "1px solid" }}></div>
          <Button
            color="primary mt-3 mr-3"
            disabled={done || attachment === ""}
            onClick={() => setIsApproveOpen(true)}>
            Approva Utente
          </Button>
          <Button
            color="danger mt-3"
            onClick={() => setIsRejectOpen(true)}
            disabled={done}>
            Rifiuta Utente
          </Button>
          {approveError && (
            <p className="mt-3 text-danger">{approveError.message}</p>
          )}
          {done && <p className="mt-3 text-success">Operazione riuscita.</p>}
        </Callout>

        <CustomModal
          isOpen={isApproveOpen}
          isLoading={approveLoading}
          sendButtonColor="primary"
          toggleModal={setIsApproveOpen}
          closeAction={() => setIsApproveOpen(false)}
          closeButtonText="Annulla"
          sendButtonText="Approva"
          sendAction={() => approveUser()}
          titleModal="Sei sicuro di voler continuare?">
          <p>Clicca su Approva per continuare.</p>
        </CustomModal>
        <CustomModal
          isOpen={isRejectOpen}
          isLoading={approveLoading}
          toggleModal={setIsRejectOpen}
          closeAction={() => setIsRejectOpen(false)}
          closeButtonText="Annulla"
          sendButtonText="Rifiuta"
          sendButtonColor="danger"
          sendAction={() => {
            rejectUser();
          }}
          titleModal="Sei sicuro di voler continuare?">
          <p>Clicca su Rifiuta per rifiutare.</p>
        </CustomModal>
      </div>
    );
  }
};

export default UserValidation;
